

    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from "../lib/Question";

    @Component({})
    export default class SinisterQuestion extends Vue {
        public sinistres = [];
        @Prop()
        public question: Question;
        addSinistre() {
            if (this.isValid()) {
                let newLine = {
                    // id: Math.floor(Math.random() * 9999 + 1),
                    date: null,
                    circonstance: '',
                    corporels: false,
                    materiels: false,
                    immateriels: false,
                    cout: 0,
                };
                this.sinistres.push(newLine);
            }
        }
        isValid() {
            return true;
            let lines = this.sinistres;

            for (i = 0; i < lines.length; i++) {
                let line = lines[i];
                if (line.date === null || line.circonstance.trim() === '' || line.cout <= 0) {
                    return false;
                }
                if (!line.corporels && !line.materiels && !line.immateriels) {
                    return false;
                }
            }
            return true;
        }
        removeSinistre(sinistre) {
            this.sinistres.splice(this.sinistres.indexOf(sinistre), 1);
        }
        save() {
            if (this.isValid()) {
                //let data = JSON.stringify(this.sinistres);
                this.question.currentResponse.value = JSON.stringify(this.sinistres);
                this.question.changedEvent.emit("");
                this.question.validate();
            }
        }
        mounted(){
            if (this.question.currentResponse.value.length) {
                this.sinistres = JSON.parse(this.question.currentResponse.value);
                console.log(this.sinistres);
            }
        }
    }

